import { render, staticRenderFns } from "./HolidaySettingsTable.vue?vue&type=template&id=8a0eb58c&scoped=true&"
import script from "./HolidaySettingsTable.vue?vue&type=script&lang=js&"
export * from "./HolidaySettingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0eb58c",
  null
  
)

export default component.exports